import { Avatar, AvatarProps, Tooltip } from '@mantine/core';
import React from 'react';

import { ReactComponent as ProfileCircleIcon } from '@portals/icons/bulk/profile-circle.svg';
import { getNameAbbreviation } from '@portals/utils';

import { useRandomColorsSeed } from '../RandomColorsSeedProvider';

export interface NameAbbreviationAvatarProps extends AvatarProps {
  name: string;
  withToolTip?: boolean;
}

export function NameAbbreviationAvatar({
  withToolTip = true,
  name,
  color,
  ...avatarProps
}: NameAbbreviationAvatarProps) {
  const { getRandomColor } = useRandomColorsSeed();
  const abbreviation = getNameAbbreviation(name);

  return (
    <Tooltip label={name} withArrow withinPortal disabled={!withToolTip}>
      <Avatar
        color={color || getRandomColor(name)}
        styles={{ placeholder: { fontWeight: 500 } }}
        {...avatarProps}
      >
        {abbreviation || <ProfileCircleIcon width="100%" height="100%" />}
      </Avatar>
    </Tooltip>
  );
}
